import { render, staticRenderFns } from "./TranslatableTabs.vue?vue&type=template&id=63337bb6&"
import script from "./TranslatableTabs.vue?vue&type=script&lang=ts&"
export * from "./TranslatableTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports